import React, { ReactNode } from 'react';

type IProps = {
  condition: boolean | string | number | undefined | null;
  children: ReactNode;
};

const If = (props: IProps) => {
  if (props.condition) {
    return <>{props.children}</>;
  }
  return null;
};

export default If;
